import { useCommonTreeGridProps } from '../../../studio-blocks/logic/columnUtils';
import DataGrid from '../../../data-grid/DataGrid';
import React from 'react';
import styled from 'styled-components';
import { GetColor } from 'venn-ui-kit';
import { UPLOAD_LEFT_CONTAINER_WIDTH } from './shared/layout';
import type { UploadPortfolioAllocatorProps } from '../types';
import { useUploadPortfolioAllocator } from '../useUniversalUploaderAllocator';

export const UploadPortfolioAllocator = ({ portfolio, accessMode }: UploadPortfolioAllocatorProps) => {
  const { rowData, columnDefs, autoGroupColumnDefs } = useUploadPortfolioAllocator(portfolio, accessMode);
  const commonGridProps = useCommonTreeGridProps();
  return (
    <PortfolioAllocatorDataGridWrapper>
      <DataGrid
        {...commonGridProps}
        rowData={rowData}
        columnDefs={columnDefs}
        domLayout="normal"
        autoGroupColumnDef={autoGroupColumnDefs}
      />
    </PortfolioAllocatorDataGridWrapper>
  );
};

const PortfolioAllocatorDataGridWrapper = styled.div`
  // ag-grid does not appear unless the parent has a height and width set
  // perhaps this is a problem with our DataGrid wrapper
  height: 100%;
  width: calc(100% - ${UPLOAD_LEFT_CONTAINER_WIDTH}px);

  // styling for portfolio review
  .ag-row-odd {
    background-color: ${GetColor.GreyScale.Grey10};
  }
  .ag-row-even {
    background-color: ${GetColor.GreyScale.Grey20};
  }
  .ag-header-container {
    background-color: ${GetColor.GreyScale.Grey10};
  }
  .ag-body-viewport.ag-layout-normal {
    ::-webkit-scrollbar {
      display: none;
    }
  }
`;
